/**
 *
 * Spinner
 *
 */

import React, { Component } from "react";
import { Dimmer, Loader } from "semantic-ui-react";

interface Props {
  className?: string;
  loading: boolean;
}

class Spinner extends Component<Props> {
  render() {
    return (
      <div>
        {this.props.loading && (
          <Dimmer active inverted id={"dimmer"}>
            <Loader inverted>Loading</Loader>
          </Dimmer>
        )}
        {!this.props.loading && this.props.children}
      </div>
    );
  }
}

export default Spinner;
